import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { firebaseConfig } from "../environment";

export const Firebase = initializeApp(firebaseConfig);
export const db = getFirestore(Firebase);
export const auth = getAuth(Firebase);
